import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { OptionColorPipe } from '@df/ui/common/option-color.pipe';
import { OptionImagePipe } from '@df/ui/common/option-image.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { NProfiles } from '../profile.interfaces';

@Component({
    selector: 'profile-color-selector',
    templateUrl: './profile-color-selector.component.html',
    styleUrls: ['./profile-color-selector.component.scss'],
    standalone: true,
    imports: [TranslationModule, OptionLabelPipe, OptionColorPipe, OptionImagePipe, DfImageDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileColorSelectorComponent extends UiComponent implements OnChanges {
    @Input({ required: true })
    colorOptions!: NProfiles.IAttributeOption[];
    @Input()
    selectedColors?: { [key: string]: boolean };
    @Input()
    title?: string;
    @Input()
    attributeCode: string = NProfiles.COLOUR_ATTRIBUTE_CODE;
    @Output()
    selectedColorsChange = new EventEmitter<{ [key: string]: boolean }>();

    protected currentSelectedColors: { [key: string]: boolean } = {};

    override ngOnInit(): void {
        this.currentSelectedColors = this.selectedColors || {};
    }

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedColors']) {
            this.currentSelectedColors = this.selectedColors || {};
        }
    }

    protected isColorSelected(optionId: number): boolean {
        return this.currentSelectedColors[optionId] || false;
    }

    protected toggleColor(optionId: number): void {
        if (this.currentSelectedColors[optionId]) {
            delete this.currentSelectedColors[optionId];
        } else {
            this.currentSelectedColors[optionId] = true;
        }

        this.selectedColorsChange.emit(this.currentSelectedColors);
    }
}
